import Swiper from 'swiper';
import SwiperCore, { Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation, Scrollbar]);
import debounce from 'lodash/debounce';

export default class MediaGridSlider {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * media grid slider element.
    **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.swiperInit = false
        this.sliderElement = sliderElement;
        this.sliderWrapper = this.sliderElement.querySelector('.js-swiper-wrapper');
        this.sliderSlides = this.sliderElement.querySelectorAll('.js-swiper-slide');
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');

        this.handleSwiperInit();

        const debouncedSwiperInit = debounce(() => {
            this.handleSwiperInit();
        }, 100);

        window.addEventListener('resize', () => {
            debouncedSwiperInit();
        });
    }

    handleSwiperInit () {
        if (window.innerWidth < 768) {
            this.swiper = new Swiper(this.sliderElement, {
                slidesPerView: 1.3,
                spaceBetween: 20,
                center: true,
                init: false,
                threshold: 10,
                navigation: {
                    nextEl: this.arrowNext,
                    prevEl: this.arrowPrev
                },
                scrollbar: {
                    el: this.scrollbar,
                    draggable: true,
                    hide: false
                }
            });

            this.sliderElement.classList.add('swiper');
            this.sliderWrapper.classList.add('swiper-wrapper');
            this.sliderSlides.forEach(slide => {
                slide.classList.add('swiper-slide');
            });
            this.swiper.init();
            this.swiperInit = true
        } else {
            this.sliderElement.classList.remove('swiper');
            this.sliderWrapper.classList.remove('swiper-wrapper');
            this.sliderSlides.forEach(slide => {
                slide.classList.remove('swiper-slide');
            });
            if (this.swiperInit) {
                this.swiper.destroy(true, true);
                this.swiperInit = false
            }
        }
    }
}
